// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1179":"077dc8b0685d4bdb","4439":"e287ec323c9ffdc9","5801":"545220c086a2010e","7744":"6e266b05005f7fec","7746":"385429c1efd4cc52","9591":"11821c4a01e85e34","9860":"b953096b114b07aa"}[chunkId] + ".1782827073505.js";
};